<template>
    <Modal title="修改密码" v-model="showModal" :width="480" :mask-closable="false">
        <Form ref="editForm" :model="editForm" :rules="editFormRules" label-colon :label-width="100">
            <FormItem label="原密码" prop="oldPwd">
                <Input type="password" placeholder="请输入" v-model="editForm.oldPwd"/>
            </FormItem>
            <FormItem label="新密码" prop="newPwd">
                <Input type="password" placeholder="请输入" v-model="editForm.newPwd"/>
            </FormItem>
            <FormItem label="确认新密码" prop="confirmPwd">
                <Input type="password" placeholder="请输入" v-model.trim="editForm.confirmPwd"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="default" @click="closeModal(false)">取消</Button>
            <Button type="primary" @click="handleSubmit" :loading="loading">确定</Button>
        </div>
    </Modal>
</template>
<script>
import {encode64} from '@/assets/js/utils';
import {updateUserPwd} from "@/api/system-api";

export default {
    name: "EditPassword",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        roleCodes: []
    },
    data() {
        return {
            loading: false,
            showModal: this.value,
            editForm: {
                oldPwd: '',
                newPwd: '',
                confirmPwd: ''
            },
            editFormRules: {
                oldPwd: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                ],
                newPwd: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {
                        pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#$%^&*]+$)[\da-zA-Z!#$%^&*]{6,16}$/,
                        message: '密码由字母和数字组成6到16位',
                        trigger: 'blur'
                    },
                ],
                confirmPwd: [{
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (!value) {
                            return callback(new Error('请再次输入新密码'));
                        }

                        if (this.editForm.newPwd !== value) {
                            callback(new Error('两次密码不一致！'));
                        } else {
                            callback();
                        }
                    }
                }]
            },
        }
    },
    methods: {
        handleSubmit() {
            this.loading = true;
            this.$refs['editForm'].validate((valid) => {
                if (!valid) {
                    this.loading = false;
                    return false;
                }

                let params = {
                    oldPwd: encode64(encode64(this.editForm.oldPwd) + 'oldPwd'),
                    newPwd: encode64(encode64(this.editForm.newPwd) + 'newPwd'),
                    confirmPwd: encode64(encode64(this.editForm.confirmPwd) + 'confirmPwd')
                }
                updateUserPwd(params).then((res) => {
                    this.loading = false;
                    if (res.data.data === 5) {
                        this.$Message.success(res.data.msg);
                        //修改密码后重新登录
                        if ((this.roleCodes || []).includes('adjustment')) {
                            this.$router.push('/login');
                        } else {
                            this.$router.push('/loginOthers');
                        }
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                });
            });
        },
        closeModal(val) {
            this.$emit('input', val);
        },
    },
    watch: {
        value(val) {
            this.showModal = val;
        },
        showModal(val) {
            if (val) {
                this.$refs['editForm'].resetFields();
            } else {
                this.closeModal(val);
            }
        }
    }
}
</script>
